export default __webpack_public_path__ + "static/media/factory__1.78e1a99c.jpg";